/* 06/15/2020 - Dennis

	The class defined here will be responsible for keeping in memory the many attributes
	that will be used across multiple objects. For that, the localStorage class will be used.
	
	Things that will be held in localStorage
	
	 - Custom Scenario data for personalized quotes
	 - User selected product with quotes

*/
import {Component} from "react";
import ProductDetails from "./ProductDetails";
class UserSession extends Component {
	
	constructor(props)
	{
		super(props);
		
		this.loadCustomQuoteData();		

	}
	
	render () {
		return null;
	}
	
	loadCustomQuoteData()
	{
		/* When the class is loaded make sure get read first from the local storage if nothing is found then set default.
			*/
		this.customQuote = localStorage.getItem("customQuote") || false;
		this.loanPurpose = localStorage.getItem("loanPurpose") || 1;
		this.loanPurposeCode = localStorage.getItem("loanPurposeCode") || "FULL DOCS REFI";
		this.loanPurposeKeyword = localStorage.getItem("loanPurposeKeyword") || "FULL DOCS REFI";
		this.purchasePrice = localStorage.getItem("purchasePrice") || 0.00;
		this.downPaymentAmount = localStorage.getItem("downPaymentAmount") || 0.00;
		this.propertyZipCode = localStorage.getItem("propertyZipCode") || "";
		this.propertyState = localStorage.getItem("propertyState") || "";
		this.propertyCounty = localStorage.getItem("propertyCounty") || "";
		this.propertyCountyName = localStorage.getItem("propertyCountyName") || "";
		this.creditScore = localStorage.getItem("creditScore") || 0;
		this.ficoScore = localStorage.getItem("ficoScore") || 0;
		this.propertyType =  localStorage.getItem("propertyType") || "";
		this.propertyTypeUnits = localStorage.getItem("propertyTypeUnits") || "";
		this.propertyUse = localStorage.getItem("propertyUse") || 0;
		this.propertyUseCode = localStorage.getItem("propertyUseCode") || "";
		this.penaltyTerm = localStorage.getItem("penaltyTerm") || "";
		this.veteran = localStorage.getItem("veteran") || false;
		this.noClosingCosts = localStorage.getItem("noClosingCosts") || false;
		this.estimatedValue = localStorage.getItem("estimatedValue") || 0.00;
		this.currentLoanBalance = localStorage.getItem("currentLoanBalance") || 0.00;
		this.cashoutAmount = localStorage.getItem("cashoutAmount") || 0.00;
		this.leadSource = localStorage.getItem("leadSource") || "";
		this.branchCode = localStorage.getItem("branchCode") || "";
		this.promoCode = localStorage.getItem("promoCode") || "";
		this.stateList = localStorage.getItem("stateList") || "";
		this.immigrationStatus = localStorage.getItem("immigrationStatus") || "1";
		this.documentType = localStorage.getItem("documentType") || "0";
		this.amortizationType = localStorage.getItem("amortizationType") || "";
		this.amortizationTerm = localStorage.getItem("amortizationTerm") || "";
		this.armValue = localStorage.getItem("armValue") || "";
		this.isDtiRatioHigher = localStorage.getItem("isDtiRatioHigher") || '';
		this.interestOnlyPayment = localStorage.getItem("interestOnlyPayment") || "";
		this.escrow = localStorage.getItem("escrow") || "";

		//store entire response of price-scenario api
		this.webOffer = localStorage.getItem("webOffer") || "";

		//Contact Info
		this.firstName = localStorage.getItem("firstName") || "";
		this.middleName = localStorage.getItem("middleName") || "";
		this.lastName = localStorage.getItem("lastName") || "";
		this.phone = localStorage.getItem("phone") || "";
		this.workPhone = localStorage.getItem("workPhone") || "";
		this.email = localStorage.getItem("email") || "";

		//Product details
		this.selectedProduct = localStorage.getItem("selectedProduct") || new ProductDetails();
		this.selectedProduct.loadSelectedProductData();	
		this.amortizationType = localStorage.getItem("amortizationType") || "";
		this.amortizationTerm = localStorage.getItem("amortizationTerm") || "";	
		this.optionalKeyword = localStorage.getItem("optionalKeyword") || "";
		this.convProductType = localStorage.getItem("convProductType") || "SC";
		this.subordinateValue = localStorage.getItem("subordinateValue") || 0;
		this.dpaProduct = localStorage.getItem("dpaProduct") || '';

	}
	
	clearData()
	{
		localStorage.clear();
	}
	
	getSelectedProduct(){
		return this.selectedProduct;
	}

	setCustomQuote(prop) {
		this.customQuote = prop;
		localStorage.setItem("customQuote", this.customQuote);
	}
	getCustomQuote() {
		return this.customQuote;
	}

	setLoanPurpose(prop) {
		this.loanPurposeCode = prop;
		localStorage.setItem("loanPurposeCode",prop);
		localStorage.setItem("loanPurposeKeyword",prop);

		let pageName = process.env.REACT_APP_URL;
		switch (prop)
		{
			
			case "PURCHASE":
			case "PURCHASE REHAB":
				if (
					pageName === "non-qmloans" ||
					pageName === "dscrloans" ||
					pageName === "foreignnational" ||
					pageName === "fha203kloans"
				) {
					this.loanPurpose = 0;
					localStorage.setItem("loanPurpose", 0);
				} else {
					this.loanPurpose = "PURCHASE";
					localStorage.setItem("loanPurpose", "PURCHASE");
				}
				
				break;
			case "FULL DOCS REFI":
			case "REFI REHAB":
				if (pageName === "conventionalloans") {
					this.loanPurpose = "LIMITED CO";
					localStorage.setItem("loanPurpose", "LIMITED CO");
					} else if (pageName === "non-qmloans" ||
					pageName === "dscrloans" ||
					pageName === "foreignnational" ||
					pageName === "fha203kloans"
				  ) {
					this.loanPurpose = 1;
					localStorage.setItem("loanPurpose", 1);
				} else {
					this.loanPurpose = "FULL DOCS REFI";
					localStorage.setItem("loanPurpose", "FULL DOCS REFI");
				}
			
				break;
			case "CASH OUT REFI":
				if (pageName === "non-qmloans" ||
					pageName === "dscrloans" ||
					pageName === "foreignnational" ||
					pageName === "fha203k"
				) {
					this.loanPurpose = 2;
					localStorage.setItem("loanPurpose", 2);
				} else {
					this.loanPurpose = "CASH OUT REFI";
					localStorage.setItem("loanPurpose", "CASH OUT REFI");
				}
				break;
			case "": // WHL-32: did mount resets in cae of no-qm only
				if (pageName === "non-qmloans" || pageName === "dscrloans") {
					this.loanPurpose = 0;
					localStorage.setItem("loanPurpose", 0);
				}
				//no default
		}
	}
	
	getLoanPurpose()
	{
		return this.loanPurpose;
	}

	getLoanPurposeCode(){
		return this.loanPurposeCode;
	}

	setLoanPurposeKeyword(prop)
	{
		this.loanPurposeKeyword = prop;
		localStorage.setItem("loanPurposeKeyword", this.loanPurposeKeyword);
	}

	getLoanPurposeKeyword(){
		return this.loanPurposeKeyword;
	}
	
	setPurchasePrice(prop)
	{
		this.purchasePrice = prop;
		localStorage.setItem("purchasePrice", this.purchasePrice);
	}
	
	getPurchasePrice()
	{
		return this.purchasePrice;
	}
	
	setDownPaymentAmount(prop)
	{
		this.downPaymentAmount = prop;
		localStorage.setItem("downPaymentAmount", this.downPaymentAmount);
	}
	
	getDownPaymentAmount()
	{
		return this.downPaymentAmount
	}

	setPropertyZipCode(prop)
	{
		this.propertyZipCode = prop;
		localStorage.setItem("propertyZipCode", this.propertyZipCode);
	}
	
	getPropertyZipCode()
	{
		return this.propertyZipCode;
	}
	
	setPropertyState(prop)
	{
		this.propertyState = prop;
		localStorage.setItem("propertyState", this.propertyState);
	}
	
	getPropertyState()
	{
		return this.propertyState;
	}
	
	setPropertyCounty(prop)
	{
		this.propertyCounty = prop;
		localStorage.setItem("propertyCounty", this.propertyCounty);
	}
	
	getPropertyCounty()
	{
		return this.propertyCounty;
	}

	setPropertyCountyName(prop)
	{
		this.propertyCountyName = prop;
		localStorage.setItem("propertyCountyName", this.propertyCountyName);
	}
	
	getPropertyCountyName()
	{
		return this.propertyCountyName;
	}

	setFicoScore(prop)
	{
		this.ficoScore = prop;
		localStorage.setItem("ficoScore", this.ficoScore);
	}

	getFicoScore()
	{
		return this.ficoScore;
	}

	setFhaType(prop)
	{
		this.optionalKeyword = prop;
		localStorage.setItem("optionalKeyword", this.optionalKeyword);
	}

	getFhaType()
	{
		return this.optionalKeyword;
	}

	setProductType(prop)
	{
		this.convProductType = prop;
		localStorage.setItem("convProductType", this.convProductType);
	}

	getProductType()
	{
		return this.convProductType;
	}
	
	setCreditScore(prop)
	{
		switch (prop)
		{
			case "Excellent":
				this.creditScore = 740;
				localStorage.setItem("creditScore", 740);
				break;
			case "VERYGOOD":
				this.creditScore = 739;
				localStorage.setItem("creditScore", 739);
				break;
			case "GOOD":
				this.creditScore = 719;
				localStorage.setItem("creditScore", 719);
				break;
			case "FAIR":
				this.creditScore = 679;
				localStorage.setItem("creditScore", 679);
				break;
			case "POOR":
				this.creditScore = 639;
				localStorage.setItem("creditScore", 639);
				break;
				//no default
		}
	}
	
	getCreditScore()
	{
		return this.creditScore;
	}
	
	setPropertyType(prop)
	{
		this.propertyType = prop;
		localStorage.setItem("propertyType", prop);
	}
	
	getPropertyType()
	{
		return this.propertyType;
	}
	
	setPropertyTypeUnits(prop)
	{
		this.propertyTypeUnits = prop;
		localStorage.setItem("propertyTypeUnits", prop);
	}
	
	getPropertyTypeUnits()
	{
		return this.propertyTypeUnits;
	}
	
	setPropertyUse(prop)
	{
		this.propertyUse = prop;
		localStorage.setItem("propertyUse", prop);
		switch (prop)
		{
			case "1":
			this.propertyUseCode = "OCCUPIED";
			localStorage.setItem("propertyUseCode", "OCCUPIED");
			break;
			case "2":
			this.propertyUseCode = "RENTAL";
			localStorage.setItem("propertyUseCode", "RENTAL");
			break;
			case "3":
			this.propertyUseCode = "SECOND HOME";
			localStorage.setItem("propertyUseCode", "SECOND HOME");
			break;
			case "BUSINESS":
			this.propertyUseCode = "BUSINESS";
			localStorage.setItem("propertyUseCode", "BUSINESS");
			break;
			case "CONSUMER":
			this.propertyUseCode = "CONSUMER";
			localStorage.setItem("propertyUseCode", "CONSUMER");
			break;
			
		}
	}
	
	getPropertyUse()
	{
		return this.propertyUse;
	}

	getPropertyUseCode(){
		return this.propertyUseCode;
	}

	setPenaltyTermInSess(prop){
		this.penaltyTerm = prop;
		localStorage.setItem("penaltyTerm", prop);
	}

	getPenaltyTermInSess(){
		return this.penaltyTerm;
	}

	getImmigrationStatus() {
		return this.immigrationStatus
	}
	setImmigrationStatus(prop) {
		this.immigrationStatus = prop;
		localStorage.setItem('immigrationStatus', prop);
	}

	getDocumentType() {
		return this.documentType;
	}

	setDocumentType(prop) {
		this.documentType = prop;
		localStorage.setItem('documentType', prop);
	}
	
	setVeteran(prop)
	{
		this.veteran = prop;
		localStorage.setItem("veteran", prop);
	}
	
	getVeteran()
	{
		return this.veteran;
	}
	
	setNoClosingCosts(prop)
	{
		this.noClosingCosts = prop;
		localStorage.setItem("noClosingCosts", prop);
	}
	
	getNoClosingCosts()
	{
		return this.noClosingCosts;
	}
	
	setEstimatedValue(prop)
	{
		this.estimatedValue = prop;
		localStorage.setItem("estimatedValue", prop);
	}
	
	getEstimatedValue()
	{
		return this.estimatedValue;
	}
	
	setCurrentLoanBalance(prop)
	{
		this.currentLoanBalance = prop;
		localStorage.setItem("currentLoanBalance", prop);
	}
	
	getCurrentLoanBalance()
	{
		return this.currentLoanBalance;
	}
	
	setCashOutAmount(prop)
	{
		this.cashoutAmount = prop;
		localStorage.setItem("cashoutAmount", prop);
	}
	
	getCashOutAmount()
	{
		return this.cashoutAmount;
	}

	getLeadSource(){
		return this.leadSource;
	}

	setLeadSource(prop) {
		this.leadSource = prop;
		localStorage.setItem("leadSource", this.leadSource);
	}

	
    getFirstName() {
        return this.firstName;
    }

    setFirstName(firstName) {
		this.firstName = firstName;
		localStorage.setItem("firstName", this.firstName);
    }

    getMiddleName() {
		return this.middleName;
		
    }

    setMiddleName(middleName) {
		this.middleName = middleName;
		localStorage.setItem("middleName", this.middleName);
    }

    getLastName() {
        return this.lastName;
    }

    setLastName(lastName) {
		this.lastName = lastName;
		localStorage.setItem("lastName", this.lastName);
    }

    getPhone() {
        return this.phone;
    }

    setPhone(phone) {
		this.phone = phone;
		localStorage.setItem("phone", this.phone);
    }

    getWorkPhone() {
        return this.workPhone;
    }

    setWorkPhone(workPhone) {
		this.workPhone = workPhone;
		localStorage.setItem("workPhone", this.workPhone);
    }

    getEmail() {
        return this.email;
    }

    setEmail(email) {
		this.email = email;
		localStorage.setItem("email", this.email);
	}
	
	getBranchCode() {
        return this.branchCode;
    }

    setBranchCode(branchCode) {
		this.branchCode = branchCode;
		localStorage.setItem("branchCode", this.branchCode);
	}
	getPromoCode() {
        return this.promoCode;
    }

    setPromoCode(promoCode) {
		this.promoCode = promoCode;
		localStorage.setItem("promoCode", this.promoCode);
	}
	getWebOffer() {
        return this.webOffer;
    }

    setWebOffer(webOffer) {
		this.webOffer = webOffer;
		localStorage.setItem("webOffer", this.webOffer);
	}
	getStateList() {
        return this.stateList;
    }

    setStateList(stateList) {
		this.stateList = stateList;
		localStorage.setItem("stateList", this.stateList);
	}

	getAmortizationType() {
		return this.amortizationType;
	}
	setAmortizationType(prop) {
		this.amortizationType = prop;
		localStorage.setItem('amortizationType', prop);
	}

	getAmortizationTerm() {
		return this.amortizationTerm;
	}
	setAmortizationTerm(prop) {
		this.amortizationTerm = prop;
		localStorage.setItem('amortizationTerm', prop);
	}
	getArmInSession() {
		return this.armValue;
	}
	setArmInSession(prop) {
		this.armValue = prop;
		localStorage.setItem('armValue', prop);
	}
	getIsDtiRatioHigher() {
		return this.isDtiRatioHigher;
	}
	setIsDtiRatioHigher(prop) {
		this.isDtiRatioHigher = prop;
		localStorage.setItem('isDtiRatioHigher', prop);
	}
	getInterestOnlyPayment() {
		return this.interestOnlyPayment;
	}
	setInterestOnlyPayment(prop) {
		this.interestOnlyPayment = prop;
		localStorage.setItem('interestOnlyPayment', prop);
	}
	getEscrow() {
		return this.escrow;
	}
	setEscrow(prop) {
		this.escrow = prop;
		localStorage.setItem('escrow', prop);
	}

	setSubordinatePrice(prop)
	{
		this.subordinateValue = prop;
		localStorage.setItem("subordinateValue", this.subordinateValue);
	}
	
	getSubordinatePrice()
	{
		return this.subordinateValue;
	}
	setDpaProduct(prop)
	{
		this.dpaProduct = prop;
		localStorage.setItem("dpaProduct", this.dpaProduct);
	}
	
	getDpaProduct()
	{
		return this.dpaProduct;
	}
};

export default UserSession;